const GTM_PRODUCTION_HOSTNAME = 'store.yassir.com'

export type GtmEventPayload = Record<
  string,
  string | number | boolean | undefined
>

export type EmailVerifiedGtmPayload = {
  restaurant_name?: string
  city?: string
  country?: string
  username?: string
}

export function isGtmEnabled(): boolean {
  return (
    typeof window !== 'undefined' &&
    window.location.hostname === GTM_PRODUCTION_HOSTNAME
  )
}

function pushGtmEvent(event: string, payload?: GtmEventPayload): void {
  if (!isGtmEnabled()) return

  const sanitizedPayload = Object.fromEntries(
    Object.entries(payload ?? {}).filter(
      ([, value]) => value !== undefined && value !== ''
    )
  )

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event,
    ...sanitizedPayload
  })
}

export function pushGtmFormSubmitEvent(payload?: GtmEventPayload): void {
  pushGtmEvent('form_submit', payload)
}

export function pushGtmEmailVerifiedEvent(
  payload?: EmailVerifiedGtmPayload
): void {
  pushGtmEvent('email_verified', payload)
}
